export const toUsersSelect = (users, args = { withTeams: true }) =>
  users.map(user => ({
    value: user.id,
    label: user.firstName + ' ' + user.lastName,
    ...(args.withTeams ? { teams: user.teams } : {})
  }))

export const fromTableViewList = list => list.map(fromTableView)

export const fromTableView = view => ({
  value: view.id,
  label: view.title,
  isPublic: view.isPublic
})
